

import Header from "./Header";



function News(){
 return (
   <div>
    <Header />

    News
   </div>
 );
 
}

export default News;